import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * The metal badge on the product media updates its text — or disappears,
 * if the product has no metal/colour option — on every variant change.
 * Copies the freshly server-rendered badge from Shopify's own variant
 * fetch rather than recomputing anything client-side.
 *
 * @extends {Component}
 */
class MetalBadgeVerrieComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    // The badge sits in the media column, a sibling of _product-details
    // (which is what carries the "ProductInformation-" id) — not a
    // descendant of it — so it needs the shared outer wrapper instead.
    const target = this.closest('.product-information, [id*="QuickAdd-"], product-card');
    if (!target) return;
    target.addEventListener(ThemeEvents.variantUpdate, this.updateBadge);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.closest('.product-information, [id*="QuickAdd-"], product-card');
    if (!target) return;
    target.removeEventListener(ThemeEvents.variantUpdate, this.updateBadge);
  }

  updateBadge = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    }

    if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newBadge = event.detail.data.html?.querySelector('.metal-badge-verrie');
    if (newBadge) {
      this.innerHTML = newBadge.innerHTML;
      this.hidden = false;
    } else {
      this.hidden = true;
    }
  };
}

if (!customElements.get('metal-badge-verrie')) {
  customElements.define('metal-badge-verrie', MetalBadgeVerrieComponent);
}
